module.exports = __webpack_public_path__ + "img/1-3-1.640b201c.png";